module.exports = __webpack_public_path__ + "static/media/icon_foodAndDrink.5ec65f4f.svg";